import { render } from "./batterys.vue?vue&type=template&id=3689a872"
import script from "./batterys.vue?vue&type=script&lang=js"
export * from "./batterys.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__